import React, { useContext, } from 'react';
import { Form, } from 'antd';
import { PermissionsContext } from '../../../../router/DashboardRoutes';

export const DeviceForm = ({...props}) => {

    const userPermissions = useContext(PermissionsContext);
    const editable = userPermissions.device.edit;

    const formDefaultProps = {
        autoComplete: 'off',
        disabled: !editable,
        ...props
    }

    return (
        <>
            <Form {...formDefaultProps}>
                {props.children}
            </Form>
        </>
    )

}